import React from "react";

import { theme } from "../../../styles/theme";

import Menu from "../../../templates/menu-template";

import { useMenu, Actions } from "../../../../contexts/menu";

const itens: any = [
  {
    key: 1,
    icon: "home",
    title: "Home",
    route: ["/home"],
  },
  {
    key: 2,
    icon: "nf",
    title: "Notas Avulsas",
    route: ["/issue"],
  },
  {
    key: 3,
    icon: "ni",
    title: "Notas Exterior",
    route: ["/exterior"],
  },
  /*  {
     key: 3,
     icon: "documents",
     title: "Documentos Emitidos",
     route: ["/documents"],
   }, */
  {
    key: 4,
    icon: "documents",
    title: "Notas Recorrentes",
    route: ["/recurrency"],
  },
  {
    key: 5,
    icon: "invoice",
    title: "Invoice",
    route: ["/invoice"],
  },
  {
    key: 6,
    icon: "exit",
    color: theme.colors.red,
    title: "Sair",
    route: ["/exit"],
  },
];

const MenuDeveloper: React.FC = () => {
  const { menu, dispatch } = useMenu();

  const toggleMenu = (): void =>
    dispatch({ type: Actions.TOGGLE_MENU_DEVELOPER });

  return (
    <Menu itens={itens} isMenuOpen={menu.developer} toggleMenu={toggleMenu} />
  );
};

export default MenuDeveloper;
